module.exports = __webpack_public_path__ + "static/img/13.bd842702.png";